export default __webpack_public_path__ + "85e549fb2dc5f5f0d63883009a475c31.png";